import { Component, inject, input, InputSignal } from '@angular/core';
import { AppendTestIdPipe } from '../../../pipes/append-test-id/append-test-id.pipe';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { INormalText } from '@web/dtos';
import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';
import { LanguageService } from '../../../services/language/language.service';

interface IQuillOperation {
  insert?: unknown;
  attributes?: {
    bold?: boolean;
    italic?: boolean;
    underline?: boolean;
    strike?: boolean;
    color?: string;
    background?: string;
    size?: string;
  };
}

export interface ISimpleListStyling {
  iconColor: string;
}

export interface ISimpleListItem {
  icon?: string;
  link?: string;
  type: 'link' | 'text';
  text: INormalText[];
}

@Component({
  selector: 'aw-simple-list',
  imports: [AppendTestIdPipe, LanguagePipe, NgStyle, NgTemplateOutlet],
  templateUrl: './simple-list.component.html',
})
export class SimpleListComponent {
  public readonly id: InputSignal<string> = input.required();
  public readonly items: InputSignal<ISimpleListItem[]> = input.required();
  protected readonly corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );
  protected readonly languageService: LanguageService = inject(LanguageService);

  protected isQuillText(value: string): boolean {
    return this.getQuillOperations(value).length > 0;
  }

  protected getQuillOperations(value: string): IQuillOperation[] {
    try {
      const delta = JSON.parse(value) as { ops?: IQuillOperation[] };
      return Array.isArray(delta.ops) ? delta.ops : [];
    } catch {
      return [];
    }
  }

  protected getOperationText(operation: IQuillOperation): string {
    return typeof operation.insert === 'string'
      ? operation.insert.replace(/\n$/, '')
      : '';
  }

  protected getFontSize(size: string | undefined): string | null {
    switch (size) {
      case 'small':
        return '0.75rem';
      case 'large':
        return '1.5rem';
      case 'huge':
        return '2.5rem';
      default:
        return null;
    }
  }
}
